export const APP_CONFIG = {
  adminPath: 'admin',
  adminUser: 'tmp',
  adminPass: 'tmppassword',
  // ใช้กำหนด base URL ของ API เช่น https://your-domain.com หรือค่าว่างเพื่อใช้ relative path
  apiBaseUrl: ''
};
